import { useEffect } from 'react'
import tagManager from 'react-gtm-module'
import { useRouteMatch  } from 'react-router-dom'

tagManager.initialize({ gtmId: 'GTM-TD93F2V' })

export default () => {
    const route = useRouteMatch()

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: { url: route.path }
        })
    }, [route.path])
}